/** Delete member — port of the original delMember(): confirm, delete (the provider also deletes their work logs), back to the list. */
import { useLocation, useNavigate } from 'react-router';
import type { Member } from '@/types/models';
import { useAction } from '@/hooks/data';
import { useConfirm } from '@/ui/kit';

export function useDeleteMember() {
  const confirm = useConfirm();
  const nav = useNavigate();
  const loc = useLocation();
  // resolves to true only when the provider confirmed the delete (remove() itself returns nothing)
  const del = useAction(async (s, id: string) => {
    await s.members.remove(id);
    return true;
  }, 'Member deleted successfully.');
  return (m: Pick<Member, 'id' | 'name'>) =>
    confirm(`Are you sure you want to delete member ${m.name}? Their work logs will also be deleted.`, async () => {
      if ((await del.run(m.id)) && loc.pathname !== '/members') nav('/members');
    });
}
